export class TabEntry {
    public id: string;
    public caption: string;

    constructor(id: string, caption: string) {
        this.id = id;
        this.caption = caption;
    }
}